import React, {useEffect, useRef} from 'react';
import './PseudoPage.less';
import {BackButton} from "elements/back-button/BackButton";
import ScrollHelper from "helpers/scroll.helper";
import {PseudoPageTitle} from "elements/pseudo-page-title/PseudoPageTitle";

export const PseudoPage = ({title, children, isNoScroll, isNoPadding, onBackClick}) => {

	const containerElement = useRef(null);

	useEffect(() => {
		if (document.body.style.overflow === 'hidden') return;

		const initialOverflow = document.body.style.overflow;

		document.body.style.overflow = 'hidden';

		return () => {
			document.body.style.overflow = initialOverflow;
		}
	}, []);

	useEffect(() => {
		if (isNoScroll) return;

		const scroll = ScrollHelper.initIScroll(containerElement.current, {
			scrollX: false,
			scrollY: true,
			scrollbars: true
		});

		return () => {
			scroll && scroll.destroy();
		};
	}, []);

	return <div className={`pseudo-page ${
		isNoPadding ? 'pseudo-page--no-padding' : ''
	}`}>
		<div className="pseudo-page__header">
			{
				onBackClick && (<div className="pseudo-page__back">
					<BackButton onClick={onBackClick}/>
				</div>)
			}
			<div className="pseudo-page__title">
				<PseudoPageTitle text={title}/>
			</div>
		</div>
		<div className="pseudo-page__contents" ref={containerElement}>
			<div className="pseudo-page__container">
				{children}
			</div>
		</div>
	</div>
}
